import React, { useState, useEffect, useRef } from 'react';
import { PostDataAPI } from './services/PostDataAPI'; // Your API service
import Header from './components/header';
import Footer from './components/footer';
import { Grid } from '@mui/material';
import SEOTags from './common/SEO';



const Figgers = () => {
    const [listFreddieFiggers, setListFreddieFiggers] = useState([]);
    const [listFiggers, setListFiggers] = useState([]);
    const [listFigghealth, setListFigghealth] = useState([]);
    const [listFiggersFoundation, setListFiggersFoundation] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1); // Track the current page
    const initialLoad = useRef(true); // To track the first render
    const pageSize = 8;
    const [clickedType, setClickedType] = useState(null);

    const formatDate = (dateString) => {
        if (dateString === "0001-01-01T00:00:00" || !dateString) {
            return "";
        }
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    const [pageNumbers, setPageNumbers] = useState({
        FreddieFiggers: 1,
        Figgers: 1,
        figghealth: 1,
        figgersfoundation: 1
    });

    const [loadingState, setLoadingState] = useState({
        FreddieFiggers: false,
        Figgers: false,
        figghealth: false,
        figgersfoundation: false,
    });
    const [hasMore, setHasMore] = useState({
        FreddieFiggers: true,
        Figgers: true,
        figghealth: true,
        figgersfoundation: true,
    });
    const handleLoadMore = (type) => {
        // Check if the current type is already loading or if there's no more data
        if (!loadingState[type] && hasMore[type]) {
            // Set the loading state to true for the specific type (this prevents duplicate calls)
            setClickedType(type);
            setLoadingState(prevState => ({
                ...prevState,
                [type]: true, // Only mark the clicked section as loading
            }));

            // Increment the page number for that specific type
            setPageNumbers(prevPages => ({
                ...prevPages,
                [type]: prevPages[type] + 1, // Increment the page number for the clicked section only
            }));
        }
    };

    // Effect for triggering fetchPosts when pageNumbers change
    useEffect(() => {
        // Only fetch posts when pageNumber changes for each type
        Object.keys(pageNumbers).forEach(type => {
            // Trigger fetch if page number is updated
            if (pageNumbers[type] > 1) {
                fetchPosts(type, pageNumbers[type]);
            }
        });
    }, [pageNumbers]); // Re-run only when pageNumbers changes

    // After posts are fetched, set loadingState to false to enable next load more
    const fetchPosts = async (type, newPageNumber) => {
        setLoadingState(prevState => ({
            ...prevState,
            [type]: true,
        }));

        try {
            let platForm = "instagram";
            const result = await PostDataAPI("socialmediaposts/getPostsByPlatform", {
                page: newPageNumber,
                pageSize,
                type,
                platForm,
            });

            if (result.success && result.data) {
                if (type == 'FreddieFiggers' && (clickedType == 'FreddieFiggers' || clickedType == null))
                    setListFreddieFiggers(prevPosts => [...prevPosts, ...result.data]);
                if (type == 'Figgers' && (clickedType == 'Figgers' || clickedType == null))
                    setListFiggers(prevPosts => [...prevPosts, ...result.data]);
                if (type == 'figghealth' && (clickedType == 'figghealth' || clickedType == null))
                    setListFigghealth(prevPosts => [...prevPosts, ...result.data]);
                if (type == 'figgersfoundation' && (clickedType == 'figgersfoundation' || clickedType == null))
                    setListFiggersFoundation(prevPosts => [...prevPosts, ...result.data]);

                setHasMore(prevState => ({
                    ...prevState,
                    [type]: result.data.length >= pageSize, // If we received less than pageSize, no more data
                }));
            } else {
                setError(result.message || "No posts available.");
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                setError("Failed to fetch posts: " + error.message);
            }
        } finally {
            // Update loading state after fetch completion
            setClickedType(null);
            setLoadingState(prevState => ({
                ...prevState,
                [type]: false,
            }));
        }
    };

    // Initial Load when the component mounts
    useEffect(() => {
        SEOTags(
            "# Figgers Instagram Posts | Freddie Figgers",
            "Stay inspired with #Figgers Instagram posts showing Freddie Figgers' remarkable achievements, impactful initiatives, and creative breakthroughs every day.",
            "# Figgers Instagram Posts, Freddie Figgers"
        );
        //if (initialLoad.current) {
        //    initialLoad.current = false;
            fetchPosts('FreddieFiggers', 1);
            fetchPosts('Figgers', 1);
            fetchPosts('figghealth', 1);
            fetchPosts('figgersfoundation', 1);
        //}
    }, []);



    return (
        <>
      
            <Header />

            <h2 className="page_heading text_transform_unset">#FiggersInspires:  <br></br>
                Explore Freddie Figgers' Social Insights</h2>
            <p className='page_subheading'>Discover the Power of Inspiration through Freddie Figgers' Hashtag Conversations</p>
            <div className="layout_container">

                <Grid row="true">
                    <Grid container spacing={1} className={'hastag-container'}>
                        {listFreddieFiggers.map((post) => (
                            <Grid item lg={3} sm={12}>
                                <div className='feed_modal'>
                                    <Grid row="true">
                                        <img src={'SocialPosts/Instagram/' + post.imagePath} alt={post.postDescription} width='100%' />

                                        <p>{post.postDescription}</p>
                                    </Grid>
                                    <Grid row="true">
                                        <Grid container className='feed_bottom'>
                                            <Grid item lg={6}>
                                                <h3>{formatDate(post.postDate)} </h3>
                                            </Grid>
                                            <Grid item lg={6} style={{ textAlign: 'right' }}>
                                                <a href={post.postLink} target='_blank'>
                                                    {/* <img src={instagra_logo} /> */}
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>
                {hasMore.FreddieFiggers && !loading.FreddieFiggers && (
                    <div className='text-center'>
                        <button onClick={() => handleLoadMore('FreddieFiggers')} className="load_more_btn">
                            Load More
                        </button>
                    </div>
                )}
                <h2 className="page_heading text_transform_unset">#Figgers</h2>  <br></br>
                <Grid row="true">
                    <Grid container spacing={1} className={'hastag-container'}>
                        {listFiggers.map((post) => (
                            <Grid key={post.id} item lg={3} sm={12}>
                                <div className='feed_modal'>
                                    <Grid row="true">
                                        <img src={'SocialPosts/Instagram/' + post.imagePath} alt={post.postDescription} width='100%' />
                                        <p>{post.postDescription}</p>
                                    </Grid>
                                    <Grid row="true">
                                        <Grid container className='feed_bottom'>
                                            <Grid item lg={6}>
                                                <h3>{formatDate(post.postDate)} </h3>
                                            </Grid>
                                            <Grid item lg={6} style={{ textAlign: 'right' }}>
                                                <a href={post.postLink} target='_blank'>
                                                    {/* <img src={instagra_logo} /> */}
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>
                {hasMore.Figgers && !loading.Figgers && (
                    <div className='text-center'>
                        <button onClick={() => handleLoadMore('Figgers')} className="load_more_btn">
                            Load More
                        </button>
                    </div>
                )}
                <h2 className="page_heading text_transform_unset">#figghealth</h2>  <br></br>
                <Grid row="true">
                    <Grid container spacing={1} className={'hastag-container'}>
                        {listFigghealth.map((post) => (
                            <Grid item lg={3} sm={12}>
                                <div className='feed_modal'>
                                    <Grid row="true">
                                        <img src={'SocialPosts/Instagram/' + post.imagePath} alt={post.postDescription} width='100%' />
                                        <p>{post.postDescription}</p>
                                    </Grid>
                                    <Grid row="true">
                                        <Grid container className='feed_bottom'>
                                            <Grid item lg={6}>
                                                <h3>{formatDate(post.postDate)} </h3>
                                            </Grid>
                                            <Grid item lg={6} style={{ textAlign: 'right' }}>
                                                <a href={post.postLink} target='_blank'>
                                                    {/* <img src={instagra_logo} /> */}
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>
                {hasMore.figghealth && !loadingState.figghealth && (
                    <div className='text-center'>
                        <button onClick={() => handleLoadMore('figghealth')} className="load_more_btn">
                            Load More
                        </button>
                    </div>
                )}
                <h2 className="page_heading text_transform_unset">#figgersFoundation</h2>  <br></br>
                <Grid row="true">
                    <Grid container spacing={1} className={'hastag-container'}>
                        {listFiggersFoundation.map((post) => (
                            <Grid item lg={3} sm={12}>
                                <div className='feed_modal'>
                                    <Grid row="true">
                                        <img src={'SocialPosts/Instagram/' + post.imagePath} alt={post.postDescription} width='100%' />
                                        <p>{post.postDescription}</p>
                                    </Grid>
                                    <Grid row="true">
                                        <Grid container className='feed_bottom'>
                                            <Grid item lg={6}>
                                                <h3>{formatDate(post.postDate)} </h3>
                                            </Grid>
                                            <Grid item lg={6} style={{ textAlign: 'right' }}>
                                                <a href={post.postLink} target='_blank'>
                                                    {/* <img src={instagra_logo} /> */}
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

                {hasMore.figgersfoundation && !loading.figgersfoundation && (
                    <div className='text-center'>
                        <button onClick={() => handleLoadMore('figgersfoundation')} className="load_more_btn">
                            Load More
                        </button>
                    </div>
                )}
                {/* <div
                    className="elfsight-app-4e980c2c-37c1-487c-9bdf-2a4bafa32438"
                    data-elfsight-app-lazy
                ></div> */}
            </div>
            <Footer />
        </>
    );
};
export default Figgers;
